import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface ActionCardDescriptionProps {
  children: React.ReactNode;
}

const DescriptionComponent: React.FC<ActionCardDescriptionProps> = ({
  children,
}) => {
  return <span className="peptalk-action-card-description">{children}</span>;
};

export const Description: React.FC<ActionCardDescriptionProps> = (
  props: ActionCardDescriptionProps
) => {
  const Component = useCustomComponent({
    componentName: 'ActionCardDescription',
    Component: DescriptionComponent,
  });

  return <Component {...props} />;
};
